
export default (
    state = {
        loading: true,
        error: false,
        responseType: '',        
        message: '',
        data: {columns:[], rows:[]}
    }, action) => {
    switch (action.type) {

        case 'GET_MATERIAL_DATA':
            return {
                ...state,
                loading: false,
                responseType:action.payload.data.responseType,
                data:action.payload.data.responseData,
            };
        

        default:

            return state;

    }

};